export enum WaterBalanceTypesEnum {
  TopDown = 0,
  BottomUp = 1,
}
